import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Extend the Window interface to include fbq
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}

const FacebookPixel = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize Facebook Pixel only once
    if (!window.fbq) {
      (function (
        f: any,
        b: Document,
        e: string,
        v: string,
        n: any,
        t: any,
        s: any
      ) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(
        window,
        document,
        "script",
        "https://connect.facebook.net/en_US/fbevents.js",
        null,
        null,
        null
      );

      window.fbq("init", "2659134404432373");
      window.fbq("track", "PageView");
    }
  }, []);

  // Track page views on route change
  useEffect(() => {
    if (window.fbq) {
      window.fbq("track", "PageView");
    }
  }, [location.pathname]);

  return (
    <noscript>
      <img
        height="1"
        width="1"
        style={{ display: "none" }}
        src="https://www.facebook.com/tr?id=2659134404432373&ev=PageView&noscript=1"
        alt=""
      />
    </noscript>
  );
};

export default FacebookPixel;
